<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Select Campaign: {{org_label}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickCancel"
                >
                    Cancel
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="margin-top: 15px"
        >

            <v-text-field
                autocomplete="off"
                label="Search"
                prepend-icon="mdi-magnify"
                v-model="full_text"
                v-on:input="update"
            >
            </v-text-field>

            <v-data-table
                v-if="results != null"
                :headers="headers"
                :items="results"
                :items-per-page="100"
                class="elevation-1"
                :hide-default-footer="true"
                disable-sort
                :footer-props="{
                    disableItemsPerPage: false,
                    disablePagination: false,
                }"
            >
            
                <template v-slot:item.time_created_date="{ item }">
                    {{ $rc.pretty(item.time_created, 'date') }}
                </template>

                <template v-slot:item.comm_network="{ item }">
                    <span class="text-capitalize">{{ item.comm_network }}</span>
                </template>

                <template v-slot:item.status="{ item }">
                    <span class="text-capitalize">{{ item.status }}</span>
                </template>

                <template v-slot:item.vetting_status="{ item }">
                    <span v-html="$rc.prettyTCRVettingStatus(item.vetting_status)"></span>
                </template>

                <template v-slot:item.elected_dca_att="{ item }">
                    <v-simple-checkbox v-ripple="false" v-model="item.elected_dca_att" disabled></v-simple-checkbox>
                </template>

                <template v-slot:item.elected_dca_t_mobile="{ item }">
                    <v-simple-checkbox v-ripple="false" v-model="item.elected_dca_t_mobile" disabled></v-simple-checkbox>
                </template>

                <template v-slot:item.elected_dca_verizon="{ item }">
                    <v-simple-checkbox v-ripple="false" v-model="item.elected_dca_verizon" disabled></v-simple-checkbox>
                </template>

                <template v-slot:item.action="{ item }">
                    <v-menu 
                        bottom 
                        offset-y  
                    >
                    
                    <template v-slot:activator="{ on }">
                            
                        <v-icon 
                            v-on="on"
                        >
                            mdi-dots-vertical-circle-outline
                        </v-icon>
                            
                    </template>
                    
                    <v-list>
                        <v-list-item
                            v-on:click="onClickAssign(item)"
                        >
                            <v-list-item-title>Assign campaign to {{org_label}}...</v-list-item-title>
                        </v-list-item>
                    
                    </v-list>
                    
                    </v-menu> 
                </template>
            
            </v-data-table>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');

export default {

    props: {
        org_label: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            dialog: false,
            last_dialog_guard: null,
            full_text: null,
            results: [],
            comm_network: 'bandwidth',

            headers: [
                { text: 'Registered', value: 'time_created_date'},

                { text: 'Brand Id', value: 'brand_id'}, 
                { text: 'Brand Name', value: 'brand_display_name'},
                { text: 'Connected Organization', value: 'organization_label'},
                { text: '# Orgs', value: 'count_organizations_utilizing'},

                { text: 'Campaign Id', value: 'campaign_id'}, 
                { text: 'Network', value: 'comm_network'},

                { text: 'Status', value: 'status'}, // TCRCampaignStatus
                { text: 'Vetting', value: 'vetting_status'}, // TCRVettingStatus
                { text: 'AT&T', value: 'elected_dca_att'},
                { text: 'T-Mobile', value: 'elected_dca_t_mobile'},
                { text: 'Verizon', value: 'elected_dca_verizon'},

                { text: 'Action', value: 'action'},                
            ],
        }
    },

    methods: {

        showDialog(comm_network)
        {
            this.comm_network = comm_network;
            this.dialog = true;
            this.last_dialog_guard = this.$router.dialog_guard;
            this.$router.dialog_guard = this.dialogGuard;
            this.doUpdate();
        },

        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/tcr/campaigns',
            
                'params' : {
                        'full_text': this.full_text,
                        'comm_network': this.comm_network,
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list campaigns',
            });
        },
        

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = this.last_dialog_guard;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.closeDialog();
                return;
            }
        
            this.closeDialog();
            next(false);
        },

        onClickSave()
        {
            this.closeDialog();
        },

        onClickCancel()
        {
            this.closeDialog();
        },

        onClickAssign(item)
        {
            this.$emit('input', {
                'brand_id': item.brand_id,
                'campaign_id': item.campaign_id,
                'comm_network': item.comm_network,
            });
            this.closeDialog();
        },

    },
}
</script>

<style lang="scss" scoped>
</style>